import { SectionTypes } from '../types';

export const isValidSchemaSection = (section: any): section is SectionTypes => 'sectionType' in section;
